module.exports = __webpack_public_path__ + "43a43ab2da8f8d8b6ca5b01f49f8e346.png";